export default "__VITE_ASSET__moNlK7AR__"